'use client';

import stylesHeader from "@/layout/header/header.module.scss";
import Image from "next/image";
import cx from "classix";
import { ROUTER_LINKS } from "@/shared/constants/links-constants";
import { getUserBearerCookie } from "@/features/user/cookies/cookie-user-bearer";
import styles from "@/_pages/error-page/error-page.module.scss";

export default function NotFound() {
  const isUserLogged = !!getUserBearerCookie();

  const scrollToTop = () => {
    window.scrollTo({
      behavior: 'smooth',
      top: 0,
    });
  };

  return (
    <html lang="en">
      <body style={{
        alignItems: 'center',
        display: 'flex',
        height: '100vh',
        justifyContent: 'center',
        width: '100vw',
      }}
      >
        <header className={stylesHeader.header}>
          <div className={stylesHeader.main}>
            <button
              className={stylesHeader.logo}
              onClick={scrollToTop}
            >
              <Image
                src="/images/roomster-logo/logo.svg"
                width={38}
                height={38}
                alt="roomster logo"
              />
            </button>

            {!isUserLogged && (
              <div className={cx(stylesHeader.login, stylesHeader.login__errorPage)}>
                <a className={styles.errorPage_button} href={ROUTER_LINKS.phoneAuth}>
                  Login
                </a>
              </div>
            )}
          </div>
        </header>

        <div className={stylesHeader.header_margin}/>

        <main className={styles.errorPage}>
          <div className={styles.errorPage_content}>
            <div className={styles.errorPage_image}>
              <Image
                src="/images/roomster-graphics/sad-girl.svg"
                alt="error image"
                fill
              />
            </div>

            <div className={styles.errorPage_info}>
              <p className={styles.errorPage_title}>
                404
              </p>

              <p className={styles.errorPage_description}>
                Page not found
              </p>

              <div className={styles.errorPage_actions}>
                <a
                  className={styles.errorPage_button}
                  href={ROUTER_LINKS.home}
                >
                  Home
                </a>

                <a
                  className={styles.errorPage_button}
                  href={isUserLogged ? ROUTER_LINKS.help : ROUTER_LINKS.phoneAuth}
                >
                  Help
                </a>
              </div>
            </div>
          </div>
        </main>
      </body>
    </html>
  );
}
